export function scrollTop(el = {}, pos = 0) {
  try {
    el.scrollTop = pos;
  } catch (error) {
    console.error(error);
  }
}
